import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import SearchBar from '../../../Component/SearchBar.js';
import { SuccessfulPopup } from '../../../Component/Modals/SuccessfulPopup.js';
import credit from '../../../assets/icons/credit.svg'
import debit from '../../../assets/icons/debit.svg'

import Table from '../../../Component/Table.js';
import { useFetcher, useNavigate } from 'react-router-dom';
import { getBlob, getData, patchData, postBlob, Postdata, PostFileData, updateData } from '../../../API/GlobalApi.js';
import { ReceivePayment } from '../../../Component/Modals/ReceivePaymentModal.js';
import exporticon from '../../../assets/icons/export-data.svg';
import debounce from 'lodash.debounce';
import Select from 'react-select'
import { UploadFee } from '../../../Component/Modals/UploadFee.js';
import { IndividualReceivePayment } from '../../../Component/Modals/IndividualStudentReceivePaymentModal.js';
import { handlePaginate } from '../../../Utils/handlePagination.js';
import { FeePlans } from '../../../Component/Modals/FeePlansModal.js';
import SearchingBar from '../../../Utils/Searching.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import { formatDateDDMMYYYY, formatDateDDMMYYYYByString, formatDateYYYYMMDD } from '../../../Utils/data&dateTime.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import { StudentLedgerDetails } from '../../../Component/Modals/StudentLegerDetails.js';
import { useHasPermission } from '../../../Utils/checkPermissions.js';
import TableSkeleton from '../../../Utils/TableSkeleton.js';
import ProfileStatus from '../../../Component/ProfileStatus.js';
import Notifier from '../../../Utils/notify.js';
import { highlightMatch } from '../../../Utils/highlightSearchFunctions.js';
import { useTableFade } from '../../../Utils/tableFadeHooks.js';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';
import { useWebSocket } from '../../../Utils/WebSocketHooks.js';
import { copyToClipboard } from '../../../Utils/copyToClipboard.js';
import { GridToggleIcon, reactSelectStyles } from '../../../Utils/selectBoxStyle.js';
import { OtherLedgerPaymentdetaisl } from './OtherPaymentLedger.js';

export const ManageStudetnsFeeDashboard = () => {

    const [selectedFeeDetails, setselectedFeeDetails] = useState([]);
    const [departmentdetails, setdepartmentdetails] = useState(null);
    const [parentorgid, setparentorgid] = useState(null);
    const [parentorgidsub, setparentorgidsub] = useState(null);
    const [Updatebtn, setUpdatebtn] = useState(false);
    const [filtermodal, setfiltermodal] = useState(false);
    const [filterQueryString, setFilterQueryString] = useState({});
    const [currentPage, setCurrentPage] = useState(0); // Starts from 0
    const [totalCount, setTotalCount] = useState(0);
    const [studentdata, setStudentsdata] = useState([]);
    const [status, setstatus] = useState();
    const [allCourses, setAllCourses] = useState([])
    const [allFeeTypes, setAllFeeTypes] = useState([])
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const hasPermission = useHasPermission()
    const [openStudentLedgerReportModal, setStudentLedgerReportModal] = useState(false)
    const [activeTab, setActiveTab] = useState('student'); // 'student' | 'advance'
    const [advanceSearchQuery, setAdvanceSearchQuery] = useState('');
    const [otherLedgerCount, setOtherLedgerCount] = useState(0);

    // Fetch the Other Ledger count on first mount so the badge is accurate
    // before the user clicks the tab (the OtherLedger component only mounts —
    // and thus only fetches — when the tab is opened).
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const result = await getData('finance/payments/non-student/?page=1');
                if (!cancelled && result) {
                    setOtherLedgerCount(result.count ?? (result.results ?? []).length);
                }
            } catch {
                // ignore — badge stays at 0; the tab itself will refetch on open
            }
        })();
        return () => { cancelled = true; };
    }, []);


    const transformStudentData = (emp) => {
        return {
            id: emp?.student_id || 'N/A',
            name: emp?.student_name || 'N/A',
            profile_type: emp?.student_profile || 'N/A',
            course_name: emp?.course_name || 'N/A',
            contact_number: emp?.primary_contact_number || 'N/A',
            permanent_registration_number: emp?.permanent_registration_number || 'N/A',
            last_credit_payment_date: emp?.last_credit_payment_date,
            last_credit_amount: emp?.last_credit_amount ?? 'N/A',
            last_credit_fee_head: emp?.last_credit_fee_head || 'N/A',
            ledger_data: emp?.ledger_data || [],
            academic_groups: emp?.academic_groups || 'N/A',
            payment_schedule: emp?.payment_schedule || [],
            payment_fee_plan: emp?.payment_fee_plan || [],
            financial_summary: emp.financial_summary,
            handleRowClick: handleRowClick,
        };
    };
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filterLoading, setFilterLoading] = useState(false);

    const [filterFeeData, setFilterFeeData] = useState([])
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);


    // 🔹 Fetch students with optional sorting/pagination
    const getStudents = async (page = 0, field = sortField, order = sortOrder, query = filterQueryString) => {
        const pageNumber = page + 1;
        const params = new URLSearchParams(query || "");

        params.set("page", pageNumber);
        if (field) params.set("type", field);
        if (order) params.set("sort_by", order);

        const url = `students/get-student-ledger-details/?${params.toString()}`;

        if (isInitialLoad) setIsLoading(true);
        else setSearchLoading(true);

        try {
            const response = await getData(url);

            if (response?.results?.data?.length > 0) {
                const results = response.results.data;
                setStudentsdata(results);
                setFilterFeeData(results)
                setTotalCount(response.count || 0);

                const firstStudentId = results[0]?.student_id;
                if (firstStudentId) {
                    await getStudentById(firstStudentId);
                }
            } else {
                setStudentsdata([]);
                setFilterFeeData([])
                setselectedFeeDetails(null);
                setTotalCount(0);
            }
        } catch (error) {
            Notifier.error("Error fetching students", "danger");
        } finally {
            if (isInitialLoad) {
                setIsLoading(false);
                setIsInitialLoad(false);
            } else {
                setSearchLoading(false);
            }
            setFilterLoading(false);
        }
    };



    const [paymentStats, setPaymentStats] = useState({
        total_credit: null,
        total_debit: null,
    });

    const isPaymentLoading = paymentStats.total_credit === null || paymentStats.total_debit === null;


    const getPaymentStats = async () => {
        try {
            const res = await getData('students/get-total-credit-debit-summary/');
            if (res) {
                setPaymentStats({
                    total_credit: res.total_credit || 0,
                    total_debit: res.total_debit || 0,
                });
            }
        } catch (err) {
            console.error("Error fetching payment stats:", err);
        }
    };

    const handleSort = (field, order) => {
        setSortField(field);
        setSortOrder(order);
        setCurrentPage(0);
        setIsFilterApplied(false);
        setFilterFeeData([]);
        const queryParams = new URLSearchParams(filterQueryString || "");
        queryParams.set("type", field);
        queryParams.set("sort_by", order);
        const newQuery = queryParams.toString();
        setFilterQueryString(newQuery);
        // Fetch first page with new sort
        getStudents(0, field, order, newQuery);
    };



    const [courseOptions, setCourseOptions] = useState([]);
    const [semesterOptions, setSemesterOptions] = useState([]);

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedSemester, setSelectedSemester] = useState(null);



    const getCourses = async () => {
        try {
            const response = await getData("academics/get-all-courses-unpaginated/");

            if (response?.data?.length) {
                // save full response for semester mapping
                setCourseOptions(response.data.map(item => ({
                    ...item,                 // keep academic_groups
                    label: item.name,
                    value: item.id,
                })));
            }
        } catch (error) {
            Notifier.error("Course getting errors");
            setCourseOptions([]);
        }
    };




    useEffect(() => {
        getCourses();
    }, []);

    const handleCourseChange = (course) => {
        setSelectedCourse(course);

        if (!course) {
            // User cleared course → reset everything
            setSemesterOptions([]);
            setSelectedSemester(null);

            setFilterQueryString({}); // clear all filters

            setCurrentPage(0);
            skipSpinnerRef.current = true;
            setFilterLoading(true);

            getStudents(0);
            return;
        }

        // Extract semesters
        const sems = course.academic_groups?.map(g => ({
            label: g.name,
            value: g.academic_group_id,
        })) || [];

        setSemesterOptions(sems);
        setSelectedSemester(null);

        // ⬅️ Add course_id to query
        setFilterQueryString({
            specialization_id: course?.value || ""
        });

        setCurrentPage(0);
        skipSpinnerRef.current = true;
        setFilterLoading(true);
    };


    const handleSemesterChange = (sem) => {
        setSelectedSemester(sem);

        setFilterQueryString(prev => ({
            ...prev,
            academic_group_id: sem?.value || ""  // semester id
        }));

        setCurrentPage(0);
        skipSpinnerRef.current = true;
        setFilterLoading(true);
    };

    const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();

    const getStudentById = async (studentId) => {
        if (!studentId) return;
        try {
            const response = await getData(`students/get-student-ledger-details/${studentId}/`);
            const data = response?.data;
            if (data) {
                const transformedDetails = transformStudentData(data);
                setselectedFeeDetails(transformedDetails);
            } else {
                setselectedFeeDetails(null);
            }
        } catch (error) {

        }
    };



    const modalOpenRef = useRef(false);

    useEffect(() => {
        modalOpenRef.current = openStudentLedgerReportModal;
    }, [openStudentLedgerReportModal]);


    const openModalStudentIdRef = useRef(null);
    // const WS_URL = 'ws://192.168.1.44:9000/ws/student-ledger-updates/';


    const handelCloseModal = () => {
        setStudentLedgerReportModal(false)
        openModalStudentIdRef.current = null
    }
    const WS_URL = process.env.REACT_APP_API_WSS_URL_ACTIVITY;


    const { connected, readyState, connect, disconnect } = useWebSocket(WS_URL, {
        onOpen: () => console.log("WS Connected"),

        onMessage: async (msg) => {
            console.log("WS message:", msg);

            // const parsed = msg.data; // 🔥 Already an object
            // console.log("parsed:", parsed);

            if (msg?.type === "student_ledger_update") {


                // Trigger ONLY if modal is open (ref prevents stale state)
                if (modalOpenRef.current && msg?.student_id) {
                    // Only fetch if modal is open AND student matches
                    if (modalOpenRef.current && msg.student_id === openModalStudentIdRef.current) {
                        await getStudentById(msg.student_id);
                    }
                }
                // await getActivityDatas(currentPageRef.current);
            }
        },



        onClose: () => console.log("WS Disconnected"),
        onError: (err) => console.error("WS Error:", err),
    });


    useEffect(() => {
        connect();
        return () => disconnect();
    }, []);





    const fetchData = async () => {
        if (isInitialLoad) setIsLoading(true);
        else setSearchLoading(true);

        try {
            await Promise.all([
                getStudents(currentPage),
                getPaymentStats()
            ]);
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            if (isInitialLoad) {
                setIsLoading(false);
                setIsInitialLoad(false);
            } else {
                setSearchLoading(false);
            }
            setFilterLoading(false);
            stopTableLoading(); // <-- REQUIRED for fade overlay
        }
    };

    useEffect(() => {
        fetchData();
    }, [currentPage, filterQueryString]);


    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
        triggerTableLoading();

        // handlePaginate({
        //     selectedPage: selected,
        //     url: 'students/get-student-ledger-details/',
        //     filterQueryString,
        //     setResults: handleSetSearchResults,
        //     setTotalCount,
        //     setFilterQueryString,
        //     triggerTableLoading,
        //     stopTableLoading
        // });
    }


    const handleRowClick = async (orgId, row, e) => {
        try {
            // Always execute this function
            const selectedOrg = row?.original;
            if (!selectedOrg || selectedOrg.id !== orgId) return;
            openModalStudentIdRef.current = orgId;
            // Modal only opens if:
            // 1️⃣ User has permission
            // 2️⃣ Event exists and target is the name
            // if (hasPermission('can-view-student-ledger-details') && e?.target.closest('.name-clickable')) {
            //     await getStudentById(orgId);
            //     setStudentLedgerReportModal(true);
            //     setparentorgid(orgId);
            // }

            if (hasPermission('can-view-student-ledger-details')) {
                await getStudentById(orgId);
                setStudentLedgerReportModal(true);
                setparentorgid(orgId);
            }

        } catch (error) {
            console.error("Error fetching student:", error);
        }
    };




    const handleExportExcel = async () => {
        try {
            // Convert filterQueryString to query params
            const params = new URLSearchParams(filterQueryString || {}).toString();
            const urlWithParams = `students/export-financial-insights/?${params}`;


            const blob = await getBlob(urlWithParams);
            const url = window.URL.createObjectURL(blob);

            // Build dynamic filename
            const courseName = selectedCourse?.label || "AllCourses";
            const semesterName = selectedSemester?.label || "AllSemesters";
            const fileName = `${courseName}_${semesterName}_students.xlsx`;

            // Trigger download
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            Notifier.error('❌ Excel export failed', 'danger');
            console.error("Export Excel error:", error);
        }
    };





    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);




    const searchValue = new URLSearchParams(filterQueryString).get("search") || "";


    const columns = useMemo(
        () => [
            // {
            //     Header: <input type='checkbox' />,
            //     accessor: 'checkbox',
            //     Cell: ({ row }) => (
            //         <input type="checkbox" checked={row.isSelected} onChange={() => row.toggleRowSelected()}
            //             style={{ cursor: 'pointer' }} />
            //     ),
            // },
            {
                Header: "Student's Name / Reg NO",
                accessor: "name",
                disableSortBy: false,
                Cell: ({ row }) => {
                    const hasPermissionToView = hasPermission('can-view-student-ledger-details');

                    return (
                        <div style={{ cursor: "default" }}>
                            <span
                                className="name-clickable"
                                style={{
                                    textAlign: "left",
                                    color: "#222F3E",
                                    fontWeight: 500,
                                    margin: 0,
                                    cursor: "pointer",
                                    display: "inline-block",
                                    textDecoration: hasPermissionToView ? "" : "none",
                                }}
                                role="button"
                                tabIndex={0}
                                title={hasPermissionToView ? "View Ledger Details" : ""}
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    await handleRowClick(row.original.id, row, e);
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: highlightMatch(row.original.name || "", searchValue),
                                }}

                            />
                            <p
                                style={{ margin: 0 }}
                            // dangerouslySetInnerHTML={{
                            //     __html: highlightMatch(row.original.name || "", searchValue),
                            // }}
                            />

                            {/* 🔍 Highlight Registration Number */}
                            <p
                                style={{ margin: 0, cursor: 'pointer', textDecoration: '' }}
                                dangerouslySetInnerHTML={{
                                    __html: highlightMatch(
                                        row.original.permanent_registration_number?.toString() || "-",
                                        searchValue
                                    ),
                                }}

                            // title="Copy Registration Number"
                            // onClick={(e) => {
                            //     e.stopPropagation()
                            //     copyToClipboard(row.original.permanent_registration_number, "Reg No copied")}
                            // }

                            />

                        </div>
                    );
                },
            },
            {
                Header: 'Contact number',
                accessor: 'mobile',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div >
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.contact_number}</p>
                    </div>
                )
            },
            {
                Header: 'Course Details',
                accessor: 'course_name',
                disableSortBy: true,
                Cell: ({ row }) => {

                    return (
                        <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.course_name}</p>
                        </div>
                    );
                }
            },
            {
                Header: 'Last Payment',
                accessor: 'last_credit_payment_date',

                Cell: ({ row }) => {
                    const rawDate = row.original.last_credit_payment_date;
                    const formattedDate = rawDate ? formatDateDDMMYYYYByString(rawDate) : "-";

                    return (
                        <div>
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                                {formattedDate}
                            </p>
                        </div>
                    );
                }

            }


        ],
        [hasPermission]
    );



    const searchInputRef = useRef(null);

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);






    const handleSetSearchResults = (data) => {
        if (Array.isArray(data?.data)) {
            setFilterFeeData(data.data);
        } else if (Array.isArray(data)) {
            setFilterFeeData(data);
        } else {
            setFilterFeeData([]);
        }
    };




    // const sourceData = useMemo(() => {

    //     if (isFilterApplied && filterFeeData?.length > 0) {
    //         return filterFeeData;
    //     }
    //     return studentdata;
    // }, [studentdata, filterFeeData, isFilterApplied]);



    const sourceData = useMemo(() => {
        return filterQueryString
            ? filterFeeData
            : studentdata;
    }, [studentdata, filterFeeData, filterQueryString]);




    const formattedData = useMemo(() => {
        return sourceData?.map((emp) => transformStudentData(emp)) || [];
    }, [sourceData]);



    return (
        <>
            {isLoading ? (
                <TableSkeleton rows={10} columns={6} showHeader={true} />
            ) : (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    overflow: "hidden",
                    position: "relative",
                }}>

                    {/* ── FIXED: Stats Cards + Title ── */}
                    <div style={{ flexShrink: 0, padding: "0 12px" }}>
                        <div className="dashboard-cards row mt-2" style={{ justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ flex: 1 }}>
                                <h2 className="main-heading" style={{ margin: 0 }}>
                                    {activeTab === 'student' ? 'Students Ledger' : 'Other Ledger'}
                                </h2>
                            </div>
                            <ProfileStatus
                                label="Credit Amount" icon={credit}
                                iconColor="#39886F" bgColor="#0E9DED0D" circleColor="#39886F"
                                transactios={isPaymentLoading ? "Loading..." : Number(paymentStats.total_credit).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                widths="400px"
                            />
                            <ProfileStatus
                                label="Debit Amount" icon={debit}
                                iconColor="red" bgColor="#FDE2E2" circleColor="#39886F"
                                transactios={isPaymentLoading ? "Loading..." : Number(paymentStats.total_debit).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                widths="400px"
                            />
                        </div>
                    </div>

                    {/* ── FIXED: Tab Bar + Search/Filters ── */}
                    <div style={{ flexShrink: 0, padding: "0 12px 8px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                        <div className="ledger-tabs-wrapper" style={{ margin: 0 }}>
                            <button
                                onClick={() => setActiveTab('student')}
                                className={`ledger-tab-btn ${activeTab === 'student' ? 'ledger-tab-active' : ''}`}
                            >
                                Student Ledger
                                <span className="ledger-tab-badge" style={{ marginLeft: '5px' }}>{totalCount}</span>
                            </button>
                            <button
                                onClick={() => setActiveTab('other')}
                                className={`ledger-tab-btn ${activeTab === 'other' ? 'ledger-tab-active' : ''}`}
                            >
                                Other Ledger
                                <span className="ledger-tab-badge" style={{ marginLeft: '5px' }}>{otherLedgerCount}</span>
                            </button>
                        </div>

                        {activeTab === 'other' && (
                            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                                <div style={{ width: "550px" }}>
                                    <div className="search-bar" style={{ position: 'relative', width: '100%' }}>
                                        <input
                                            type="text"
                                            className="search-input"
                                            placeholder="Search by contact number..."
                                            value={advanceSearchQuery}
                                            onChange={(e) => setAdvanceSearchQuery(e.target.value)}
                                            style={{
                                                width: '100%',
                                                paddingRight: '50px',
                                                outlineColor: '#7F56DA',
                                                outlineWidth: '1px',
                                                outlineStyle: 'solid',
                                            }}
                                        />
                                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                            width="23" height="23"
                                            style={{ position: 'absolute', right: '26px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', stroke: '#000000' }}
                                        >
                                            <path d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z"
                                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'student' && (
                            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                                <div style={{ width: "480px" }}>
                                    <SearchingBar
                                        placeholder="Search by name, mobile no, reg. no…"
                                        url="/students/get-student-ledger-details/"
                                        filterQueryString={filterQueryString}
                                        setResults={handleSetSearchResults}
                                        ref={searchInputRef}
                                        setTotalCount={setTotalCount}
                                        setFilterQueryString={setFilterQueryString}
                                        setSearchLoading={setSearchLoading}
                                        setCurrentPage={setCurrentPage}
                                        showToggle={true}
                                        toggleOnIcon={<GridToggleIcon isDisabled={false} />}
                                        toggleOffIcon={<GridToggleIcon isDisabled={true} />}
                                    />
                                </div>
                                <div style={{ width: "180px" }}>
                                    <Select
                                        options={courseOptions}
                                        value={selectedCourse}
                                        onChange={handleCourseChange}
                                        isClearable
                                        placeholder="Select Course"
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        styles={{
                                            ...reactSelectStyles,
                                            control: (base, state) => ({
                                                ...reactSelectStyles.control?.(base, state),
                                                minHeight: "34px",
                                            }),
                                        }}
                                    />
                                </div>
                                <div style={{ width: "180px" }}>
                                    <Select
                                        options={semesterOptions}
                                        value={selectedSemester}
                                        onChange={handleSemesterChange}
                                        isClearable
                                        placeholder="Select Semester"
                                        isDisabled={!selectedCourse}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        styles={{
                                            ...reactSelectStyles,
                                            control: (base, state) => ({
                                                ...reactSelectStyles.control?.(base, state),
                                                minHeight: "34px",
                                            }),
                                        }}
                                    />
                                </div>
                                <button
                                    className="filter-btn"
                                    style={{ background: "white", border: "1px solid black", height: "34px" }}
                                    onClick={handleExportExcel}
                                    title="Export Data"
                                >
                                    <img src={exporticon} alt="Export" />
                                </button>
                            </div>
                        )}
                    </div>

                    {activeTab === 'other' ? (
                        <OtherLedgerPaymentdetaisl searchQuery={advanceSearchQuery} onCountChange={setOtherLedgerCount} />
                    ) : (
                        <>


                            {/* ── SCROLLABLE: Table only ── */}
                            <div style={{
                                flex: 1,
                                minHeight: 0,
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                                padding: "0 12px",
                                position: "relative",
                            }}>
                                {filterLoading ? (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                                        <SpinnerLoader />
                                    </div>
                                ) : formattedData?.length > 0 ? (
                                    <>
                                        <AdvanceTable
                                            columns={columns}
                                            pageCounts={pageCounts}
                                            handlePageChange={handlePageChange}
                                            selectedData={selectedFeeDetails}
                                            data={formattedData}
                                            handleRowClick={handleRowClick}
                                            currentPage={currentPage}
                                            handleSort={handleSort}
                                            sortField={sortField}
                                            sortOrder={sortOrder}
                                        />
                                        <TableLoaderOverlay isLoading={tableLoading} />
                                    </>
                                ) : (!isLoading && !isSearchLoading && (
                                    <div style={{
                                        display: "flex", flexDirection: "column",
                                        alignItems: "center", justifyContent: "center",
                                        flex: 1, color: "#888", textAlign: "center",
                                    }}>
                                        No Student available.
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                </div>
            )}


            <StudentLedgerDetails isOpen={openStudentLedgerReportModal} onClose={handelCloseModal}

                selectedFeeDetails={selectedFeeDetails} />
        </>
    );
};

